module.exports = __webpack_public_path__ + "img/control_device.f6e4fc7f.svg";